<template>
    <section class="checkins">
        <!-- <timeline></timeline> -->
        <div class="panel">
            <div class="panel-heading">
                <h2>Weekly Check-In</h2>
            </div>
            <div class="panel-body">
                <ul class="checkins" v-if="checkins && mentees">
                    <li v-for="checkin in checkins" :id="'checkin_'+checkin.id" v-if="isFirstInWeek(checkin)" :class="{'disabled': isNotActive(checkin.startDate) }">

                        <div class="row checkin">
                            <div v-if="localStorage.roles.includes('Student') || localStorage.roles.includes('CampusStudent')" class="thumbnail-image col-sm-1">
                                <img v-if="checkin.checkin && checkin.checkin.demo_reel_update" :src="checkin.checkin.demo_reel_update.files[0].thumbnail">
                                <div class="blue-stripe" v-if="checkin.checkin && checkin.checkin.demo_reel_update">
                                </div>
                            </div>
                            <div class="main" :class="{'col-sm-10':localStorage.roles.includes('Student') || localStorage.roles.includes('CampusStudent'),
                                         'col-sm-11':localStorage.roles.includes('Mentor')}" @click.prevent="selectCheckin(checkin.id)">
                                <div class="blue-stripe" v-if="!submitted(checkin) || !checkin.checkin.demo_reel_update">
                                </div>
                                <div class="col-xs-6">
                                    <h3 v-if="isOnlineStudent">Week {{checkin.week}}</h3>
                                    <h3 v-else>{{checkin.startDate | checkinDate}}</h3>
                                    <div class="status-line">
                                        <i class="status-icon fa fa-check" v-if="submitted(checkin)"></i>
                                        <i class="status-icon fa fa-times animated" v-if="isOverdue(checkin) && !submitted(checkin)"></i>
                                        <span class="status-date" :title="formatFullDate(checkin.dueDate)">
                                            {{ formatShortDate(checkin.dueDate) }}
                                        </span>
                                        <span class="status-extra status-extra-bad" v-if="isOverdue(checkin) && !submitted(checkin)">
                                            Past Due
                                        </span>
                                        <span class="status-extra" v-if="!isOverdue(checkin) && !submitted(checkin)">
                                            Due
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="icon col-sm-1">
                                <i class="fa fa-question" v-if="!checkin.checkin"></i>
                                <img v-if="checkin.checkin && checkin.checkin.overallStatus === 'excellent'" src="../assets/img/mood-excellent.svg">
                                <img v-if="checkin.checkin && checkin.checkin.overallStatus === 'good'" src="../assets/img/mood-good.svg">
                                <img v-if="checkin.checkin && checkin.checkin.overallStatus === 'meh'" src="../assets/img/mood-meh.svg">
                                <img v-if="checkin.checkin && checkin.checkin.overallStatus === 'bad'" src="../assets/img/mood-not-great.svg">
                                <img v-if="checkin.checkin && !checkin.checkin.overallStatus && localStorage.roles.includes('Mentor')" src="../assets/img/mood-excellent.svg">
                            </div>
                        </div>
                        <div class="row">
                            <div v-if="!localStorage.roles.includes('Mentor')">
                                <!-- NEW CHECK-IN -->
                                <div v-if="openCheckin==checkin.id && !checkin.checkin" class="scroll-wrapper col-xs-10 col-xs-push-1">
                                    <scroll-area ref="scrollbar" :showScrollbar="true" :dragScrollEnabled="false">
                                        <form @submit.prevent="submitCheckin(checkin.id, checkin.week)" class="checkin">
                                            <h4>Weekly Check-In</h4>
                                            <div class="attended" v-if="!isAlumni">
                                                <label class="heading">Did you attend your mentorship session this week?</label>
                                                <div class="radio-wrapper">
                                                    <div>
                                                        <label>
                                                            <input type="radio" v-model="studentAttended" value="yes"><span class="dot"></span>
                                                            Yes
                                                        </label>
                                                    </div>
                                                    <div>
                                                        <label>
                                                            <input type="radio" v-model="studentAttended" value="no"><span class="dot"></span>
                                                            No
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div v-if="studentAttended === 'yes'" class="form-group">
                                                <label class="heading" v-if="isAlumni">How was your week?</label>
                                                <label class="heading" v-else>How was your mentorship session?</label>
                                                <div class="radio-wrapper">
                                                    <div v-for="status in statuses">
                                                        <label>
                                                            <input type="radio" name="overallStatus" v-model="newCheckin.overallStatus" :value="status.value">
                                                            <span class="dot"></span>
                                                            {{status.label}}
                                                        </label>
                                                    </div>
                                                </div>
                                                <label>Please share a few words about how your <span v-if="!isAlumni">mentorship session(s) this</span> week went.</label>
                                                <div class="textarea-wrapper">
                                                    <textarea class="form-control" v-model="newCheckin.mentorshipStatusDetails">
                                                    </textarea>
                                                </div>
                                            </div>
                                            <div v-if="studentAttended === 'no'">
                                                <label class="heading">Why were you unable to attend?</label>
                                                <div class="textarea-wrapper">
                                                    <textarea class="form-control" v-model="newCheckin.reasonMissed">
                                                    </textarea>
                                                </div>
                                            </div>
                                            <div class="form-group" v-if="!isAlumni">
                                                <label class="heading">
                                                    How is your progress so far?
                                                </label>
                                                <div class="radio-wrapper">
                                                    <div v-for="status in statuses">
                                                        <label>
                                                            <input type="radio" name="mentorshipStatus" v-model="newCheckin.mentorshipStatus" :value="status.value">
                                                            <span class="dot"></span>
                                                            {{status.label}}
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="form-group" v-if="!isAlumni">
                                                <label class="heading">
                                                    Please share a few words about how your mentorship is going overall. <sup>(optional)</sup>
                                                </label>
                                                <div class="textarea-wrapper">
                                                    <textarea class="form-control" v-model="newCheckin.overallStatusDetails">
                                                    </textarea>
                                                </div>
                                            </div>
                                            <div class="form-group" v-if="localStorage.roles.includes('CampusStudent')">
                                                <span v-if="isAlumni">
                                                    If you need IT / Machine support please <router-link to="/help">create a support ticket</router-link>.
                                                </span>
                                                <span v-else>
                                                    If you need IT / Machine support please <a href="https://www.wrike.com/frontend/requestforms/index.html?token=eyJhY2NvdW50SWQiOjkyNjY5NSwidGFza0Zvcm1JZCI6MjM3MzkwfQk0NzIyNjA0MzY3NjAwCTlmMGQ1MzM0YTMxNjk4NDhkZmVhYmEyMTY0YmViY2U2MmEyZmZmYmRmNjYyODc3NWNmMjNlZTk2ZjI0MTFjMWI=" target="_blank">complete this form</a>.
                                                </span>
                                            </div>
                                            <div class="form-group" v-if="isAlumni">
                                                <label class="heading">How often are you using a workstation at Think Tank?</label>
                                                <div class="radio-wrapper">
                                                    <div>
                                                        <label>
                                                            <input type="radio" name="workstationUsage" v-model="newCheckin.workstationUsage" value="over_60">
                                                            <span class="dot"></span>
                                                            More than 60 hours per week
                                                        </label>
                                                    </div>
                                                    <div>
                                                        <label>
                                                            <input type="radio" name="workstationUsage" v-model="newCheckin.workstationUsage" value="over_40">
                                                            <span class="dot"></span>
                                                            More than 40 hours per week
                                                        </label>
                                                    </div>
                                                    <div>
                                                        <label>
                                                            <input type="radio" name="workstationUsage" v-model="newCheckin.workstationUsage" value="over_20">
                                                            <span class="dot"></span>
                                                            More than 20 hours per week
                                                        </label>
                                                    </div>
                                                    <div>
                                                        <label>
                                                            <input type="radio" name="workstationUsage" v-model="newCheckin.workstationUsage" value="over_10">
                                                            <span class="dot"></span>
                                                            More than 10 hours per week
                                                        </label>
                                                    </div>
                                                    <div>
                                                        <label>
                                                            <input type="radio" name="workstationUsage" v-model="newCheckin.workstationUsage" value="under_10">
                                                            <span class="dot"></span>
                                                            Less than 10 hours per week
                                                        </label>
                                                    </div>
                                                    <div>
                                                        <label>
                                                            <input type="radio" name="workstationUsage" v-model="newCheckin.workstationUsage" value="never">
                                                            <span class="dot"></span>
                                                            Not at all
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="form-group">
                                                <label class="checkbox-wrapper">
                                                    <input type="checkbox" v-model="newCheckin.important">
                                                    Mark this as important for Think Tank staff to see and be notified.
                                                </label>
                                            </div>
                                            <div v-if="localStorage.roles.includes('Student') || localStorage.roles.includes('CampusStudent')">
                                                <h5>Your Demo Reel</h5>
                                                <div class="form-group">
                                                    <label class="heading">
                                                        Please attach at least one image or video (mp4) to update Think Tank on your progress.
                                                    </label>
                                                    <div class="dropzone-wrapper">
                                                        <dropzone id="checkinFiles" ref="checkinFiles" url="#" v-bind:use-custom-dropzone-options="true" v-bind:thumbnail-height="0" v-bind:dropzone-options="dropzoneOptions">
                                                        </dropzone>
                                                    </div>
                                                </div>
                                            </div>
                                            <button type="submit" class="btn btn-success" :disabled="isSubmitting">Submit Check-In</button>
                                        </form>
                                    </scroll-area>
                                </div>
                                <!-- COMPLETED CHECK-IN -->
                                <div v-if="checkin.checkin && openCheckin==checkin.id" class="scroll-wrapper col-xs-10 col-xs-push-1">
                                    <scroll-area ref="scrollbar" :showScrollbar="true" :dragScrollEnabled="false">
                                        <div class="completed-checkin">
                                            <div>
                                                <h4>Weekly Check-In</h4>
                                                <div v-if="checkin.checkin.reasonMissed">
                                                    <label class="heading">Why were you unable to attend?</label>
                                                    <div class="textarea-wrapper">
                                                        <textarea readonly class="form-control" :value="checkin.checkin.reasonMissed">
                                                        </textarea>
                                                    </div>
                                                </div>
                                                <div v-else class="form-group">
                                                    <label class="heading">How was your mentorship session?</label>
                                                    <div class="radio-wrapper">
                                                        <div v-for="status in statuses">
                                                            <label>
                                                                <span class="dot" :class="{'selected':status.value === checkin.checkin.overallStatus}"></span>
                                                                {{status.label}}
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="form-group">
                                                    <label>Please share a few words about how your mentorship session(s) this week went.</label>
                                                    <div class="textarea-wrapper">
                                                        <textarea readonly class="form-control" :value="checkin.checkin.mentorshipStatusDetails">
                                                        </textarea>
                                                    </div>
                                                </div>
                                                <div class="form-group" v-if="!isAlumni">
                                                    <label class="heading">How is your progress so far?</span>
                                                    </label>
                                                    <div class="radio-wrapper">
                                                        <div v-for="status in statuses">
                                                            <label>
                                                                <span class="dot" :class="{'selected':status.value === checkin.checkin.mentorshipStatus}"></span>
                                                                {{status.label}}
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="form-group" v-if="!isAlumni">
                                                    <label class="heading">
                                                        Please share a few words about how your mentorship is going overall.
                                                    </label>
                                                    <div class="textarea-wrapper">
                                                        <textarea readonly class="form-control" :value="checkin.checkin.overallStatusDetails">
                                                        </textarea>
                                                    </div>
                                                </div>
                                                <div class="submission-date">
                                                    Submitted on {{ formatFullDate(checkin.checkin.createdAt) }}
                                                </div>
                                                <!--<div class="submission-date">
                                                    Submitted on {{ formatFullDate(checkin.checkin.updatedAt) }}
                                                </div>-->
                                            </div>
                                            <div class="completed-demo-reel" v-if="localStorage.roles.includes('Student') || localStorage.roles.includes('CampusStudent')">
                                                <div class="form-group">
                                                    <label class="heading">
                                                        Please attach at least one image or video (mp4) to update Think Tank on your progress.
                                                    </label>
                                                    <ul class="files demo-reel-thumbs">
                                                        <li v-for="file in checkin.checkin.demo_reel_update.files">
                                                            <a :href="file.file" target="_blank">
                                                                <img :src="file.thumbnail">
                                                            </a>
                                                        </li>
                                                    </ul>
                                                </div>
                                                <div class="submission-date">
                                                    Submitted on {{ formatFullDate(checkin.checkin.demo_reel_update.updatedAt) }}
                                                </div>
                                            </div>
                                        </div>
                                    </scroll-area>
                                </div>
                            </div>
                            <!-- STUDENT EVALUATIONS -->
                            <div class="col-xs-11 mentees" v-if="mentees && openCheckin===checkin.id && localStorage.roles.includes('Mentor')">
                                <h4>Student Evaluations</h4>
                                <p>Please complete your evaluations after your session(s) this week.</p>
                                <div class="tabs">
                                    <ul class="clearfix">
                                        <li @click="selectedStudent = $menteeIndex" v-for="(mentee, $menteeIndex) in mentees" :class="{'active': selectedStudent === $menteeIndex}">
                                            {{mentee.firstName}} {{mentee.lastName}}
                                        </li>
                                    </ul>
                                </div>
                                <div v-if="selectedStudent === $menteeIndex" class="row" v-for="(mentee, $menteeIndex) in mentees">                                    
                                    <div v-if="hasEvaluation(checkin, mentee.id)">
                                        <weekly-evaluation :checkin="checkin" :studentId="mentee.id" :statuses="statuses"></weekly-evaluation>
                                    </div>
                                    <div v-else>
                                        <div v-if="getMeetingForWeek(checkin, mentee.meetings) && getMeetingForWeek(checkin, mentee.meetings).location && getMeetingForWeek(checkin, mentee.meetings).location !== 'remote'">
                                            <div class="form-group">
                                                <label class="heading">Did you have your sessions with {{mentee.firstName}} {{mentee.lastName}} this week?</label>
                                                <div class="radio-wrapper">
                                                    <div>
                                                        <label>
                                                            <input type="radio" v-model="campusMentorAttended" value="yes"><span class="dot"></span>
                                                            Yes
                                                        </label>
                                                    </div>
                                                    <div>
                                                        <label>
                                                            <input type="radio" v-model="campusMentorAttended" value="no"><span class="dot"></span>
                                                            No
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div v-if="campusMentorAttended === 'yes'" class="form-group">

                                                <label class="heading">How was your mentorship session(s) in relation to {{mentee.firstName}} {{mentee.lastName}}?</label>
                                                <div class="radio-wrapper">
                                                    <div v-for="status in statuses">
                                                        <label>
                                                            <input type="radio" name="participation" v-model="newCheckin.students[$menteeIndex].participation" :value="status.value">
                                                            <span class="dot"></span>
                                                            {{status.label}}
                                                        </label>
                                                    </div>
                                                </div>

                                                <label class="heading">Please share a few words about how your mentorship session went and what was covered in relation to {{mentee.firstName}} {{mentee.lastName}}</label>
                                                <div class="textarea-wrapper">
                                                    <textarea class="form-control" v-model="newCheckin.students[$menteeIndex].sessionComments">
                                                    </textarea>
                                                </div>

                                            </div>
                                            <div v-if="campusMentorAttended === 'no'" class="form-group">
                                                <label class="heading">We see you missed your meeting this week with {{mentee.firstName}} {{mentee.lastName}}, what happened?</label>
                                                <div class="textarea-wrapper">
                                                    <textarea class="form-control" v-model="newCheckin.students[$menteeIndex].reasonMissed">
                                                    </textarea>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-else>
                                            <div v-if="!getMeetingForWeek(checkin, mentee.meetings) || !getMeetingForWeek(checkin, mentee.meetings).attendees.includes(localStorage.user_id.toString())" class="form-group">
                                                <label class="heading">We see you missed your meeting this week with {{mentee.firstName}} {{mentee.lastName}}, what happened?</label>
                                                <div class="textarea-wrapper">
                                                    <textarea class="form-control" v-model="newCheckin.students[$menteeIndex].reasonMissed">
                                                    </textarea>
                                                </div>
                                            </div>

                                            <div v-else class="form-group">
                                                <label class="heading">How was your mentorship session(s) in relation to {{mentee.firstName}} {{mentee.lastName}}?</label>
                                                 <div class="radio-wrapper">
                                                    <div v-for="status in statuses">
                                                        <label>
                                                            <input type="radio" name="participation" v-model="newCheckin.students[$menteeIndex].participation" :value="status.value">
                                                            <span class="dot"></span>
                                                            {{status.label}}
                                                        </label>
                                                    </div>
                                                </div>

                                               <label class="heading">Please share a few words about how your mentorship session went and what was covered in relation to {{mentee.firstName}} {{mentee.lastName}}</label>
                                                <div class="textarea-wrapper">
                                                    <textarea class="form-control" v-model="newCheckin.students[$menteeIndex].sessionComments">
                                                    </textarea>
                                                </div>
                                                
                                            </div>
                                        </div>
                                        <div class="form-group">
                                            <label class="heading">How was {{mentee.firstName}} {{mentee.lastName}}'s progress this week?</label>
                                            <div class="radio-wrapper">
                                                <div v-for="status in statuses">
                                                    <label>
                                                        <input type="radio" name="progress" v-model="newCheckin.students[$menteeIndex].progress" :value="status.value">
                                                        <span class="dot"></span>
                                                        {{status.label}}
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="form-group">
                                            <div v-if="(mentee.roles.includes('CampusStudent') || mentee.transitioned === true) && !isRemote(getMeetingForWeek(checkin, mentee.meetings))">
                                                <label class="heading" v-if="!hasEvaluation(checkin, mentee.id)">
                                                    <span v-if="campusMentorAttended == 'no'">
                                                        Please share a few words about {{mentee.firstName}} {{mentee.lastName}}'s progress this week, including how they're progressing and what they're working on.
                                                    </span>
                                                    <span v-else>
                                                        Please share a few words about {{mentee.firstName}} {{mentee.lastName}} progress this week, including how they're progressing and what they're working on.
                                                    </span>
                                                </label>
                                            </div>
                                            <div v-else>
                                                <label class="heading" v-if="!hasEvaluation(checkin, mentee.id)">
                                                    <span v-if="!attended(checkin)">
                                                        Please share a few words about {{mentee.firstName}} {{mentee.lastName}}'s progress this week, including how they're progressing and what they're working on.
                                                    </span>
                                                    <span v-else>
                                                        Please share a few words about {{mentee.firstName}} {{mentee.lastName}} progress this week, including how they're progressing and what they're working on.
                                                    </span>
                                                </label>
                                            </div>
                                            <div class="textarea-wrapper">
                                                <textarea class="form-control" v-model="newCheckin.students[$menteeIndex].comments">
                                                </textarea>
                                            </div>
                                        </div>
                                        <div class="form-group">
                                            <label class="checkbox-wrapper">
                                                <input type="checkbox" v-model="newCheckin.students[$menteeIndex].important">
                                                Mark this as important for Think Tank staff to see and be notified.
                                            </label>
                                        </div>
                                        <button v-if="!hasEvaluation(checkin, mentee.id)" @click.prevent="submitEvaluation(newCheckin.students[$menteeIndex], checkin, getMeetingForWeek(checkin, mentee.meetings))" class="btn btn-success submit-evaluation">Save Evaluation</button>
                                    </div>
                                </div>
                                <div class="pagination">
                                    <span>Student {{selectedStudent + 1}} / {{mentees.length}}</span>
                                    <ul>
                                        <li v-for="(mentee,$menteeIndex) in mentees">
                                            <span class="dot" :class="{'selected':selectedStudent===$menteeIndex}" @click="selectedStudent = $menteeIndex">
                                            </span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>
                <div v-else class="no-checkins">No checkins yet</div>
            </div>
        </div>
    </section>
</template>
<script>
import checkins from '../services/checkins';
import mentors from '../services/mentors';
import aws from '../services/aws';

import ScrollArea from './reusable/scroll-area';
//import timeline from './widgets/Timeline.vue';
import WeeklyEvaluation from './widgets/WeeklyEvaluation.vue';

import Dropzone from 'vue2-dropzone';
import toastr from 'toastr';
import moment from 'moment';
import VueScrollTo from 'vue-scrollto';

export default {
    data() {
        return {
            isSubmitting: false,
            checkins: null,
            openCheckin: null,
            mentees: null,
            selectedStudent: null,
            selectedEvaluation: null,
            studentAttended: null,
            campusMentorAttended: null,
            statuses: [
                { label: 'Excellent!', value: 'excellent' },
                { label: 'Good', value: 'good' },
                { label: 'Not Great', value: 'meh' },
                { label: 'Bad', value: 'bad' }
            ],
            newCheckin: {
                overallStatus: null,
                overallStatusDetails: null,
                mentorshipStatus: null,
                mentorshipStatusDetails: null,
                machineStatus: null,
                workstationUsage: null,
                important: null,
                reasonMissed: null
            },
            dropzoneOptions: {
                autoProcessQueue: false,
                uploadMultiple: true,
                addRemoveLinks: true,
                dictDefaultMessage: '(drag files here)'
            },
        }
    },

    components: {
        Dropzone,
        ScrollArea,
        //timeline,
        WeeklyEvaluation
    },

    async mounted() {
        if (localStorage.roles.includes('Mentor')) {
            await this.getGroup();
        } else {
            this.mentees = [];
        }
        if (localStorage.group.split(',').includes('22')) this.studentAttended = 'yes';
        await this.getCheckins();


    },

    methods: {
        isRemote(meeting) {
            if (!meeting) return false;
            if (!meeting.location) return true;
            return meeting.location !== 'remote';
        },
        getMeetingForWeek(checkin, meetings) {
            const start = moment(checkin.startDate).startOf('week').add(1,'day').toDate()
            const end = moment(checkin.startDate).endOf('week').add(1,'day').toDate()
           
            const weeksMeetings = meetings
                .filter((m) => { return new Date(m.startTime) > start && new Date(m.startTime) < end })
                .map((m)=>{
                    if (!m.attendees) m.attendees = [];
                    return m;
                });
            
        
            const meeting = weeksMeetings.find(m => m.attendees.includes(localStorage.user_id) || m.participants.includes(localStorage.user_id) || m.participants.includes(localStorage.user_id.toString()));

            if (meeting) {
                return meeting;
            } else {
                if (weeksMeetings.length > 0) {
                    return weeksMeetings[0];
                } else {
                    return null;
                }
            }
        },
        isOverdue(checkin) {
            return new Date(checkin.dueDate) < new Date();
        },
        submitted(checkin) {

            if (localStorage.roles.includes('Mentor')) {
                return checkin.checkin && checkin.checkin.weekly_evaluations.length >= this.mentees.length;
            } else {
                return !!checkin.checkin;
            }
        },

        getGroup() {
            this.mentees = null;
            return new Promise((resolve, reject) => {
                mentors.getGroup(this, ['includeCheckins']).then((response) => {
                    if (response.data.success === true) {
                        this.mentees = response.data.members
                            .filter((m) => { return m.id != localStorage.user_id })
                            .sort((a, b) => { return b.lastName.localeCompare(a.lastName); })
                            .map((s) => {
                                s.weeklyCheckins = {};
                                if (s.checkins) {
                                    s.checkins.forEach((c) => {
                                        s.weeklyCheckins[c.week] = c;
                                    });
                                }
                                return s;
                            });

                        this.newCheckin.students = [];
                        this.mentees.forEach((m) => {
                            this.newCheckin.students.push({ studentId: m.id, morale: null, participation: null, reasonMissed: null, progress: null, comments: null, important: null })
                        });
                        this.selectedStudent = 0;

                    } else {
                        toastr.error('Error getting mentees');
                    }
                    resolve();
                });
            });
        },
        async getCheckins() {
            const res = await checkins.get();
            this.checkins = res.checkins
            if (this.$route.query.id) {
                this.openCheckin = parseInt(this.$route.query.id);
            }
        },
        isFirstInWeek(checkin) {
            let firstCheckinInWeek = this.checkins.filter((c) => { return c.week === checkin.week && c.termId === checkin.termId }).sort((a, b) => { return new Date(a.startTime) - new Date(b.startTime) })[0];
            return firstCheckinInWeek.id === checkin.id;
        },
        isNotActive(startDate) {
            return new Date(startDate) > new Date();
        },

        hasEvaluation(checkin, menteeId) {
            if (!checkin.checkin) return false;
            if (!checkin.checkin.weekly_evaluations) return false;

            const evaluation = checkin.checkin.weekly_evaluations.findIndex((e) => { return e.studentId === menteeId });
            return evaluation > -1;

        },
        validateCheckin() {




            if (localStorage.roles.includes('Student') || localStorage.roles.includes('CampusStudent')) {

                if (!this.isAlumni) {

                    if ((this.newCheckin.mentorshipStatus === 'bad' || this.newCheckin.mentorshipStatus === 'meh') && !this.newCheckin.overallStatusDetails) {
                        let status = this.newCheckin.mentorshipStatus;
                        if (status === 'meh') status = 'not great';
                        toastr.error('Please explain why the progress was ' + status + ' this week');

                    }

                }
                if ((this.newCheckin.overallStatus === 'bad' || this.newCheckin.overallStatus === 'meh') && !this.newCheckin.mentorshipStatusDetails) {
                    let status = this.newCheckin.mentorshipStatus;
                    if (status === 'meh') status = 'not great';
                        toastr.error('Please explain why the session was ' + status + ' this week');
                    return false;
                }


                if (!this.newCheckin.reasonMissed) {
                    if (!this.newCheckin.overallStatus) {
                        toastr.error('Please fill out all required Mentorship fields');
                        return false;
                    }
                }

                if (!this.newCheckin.mentorshipStatus && !this.isAlumni) {
                    toastr.error('Please fill out all required Mentorship fields');
                    return false;
                }

                if (this.$refs.checkinFiles[0].dropzone.files.length === 0) {
                    toastr.error('Please add at least one image or video');
                    return false;
                }

                const validFileTypes = ['image/gif', 'image/jpeg', 'image/tiff', 'image/png', 'video/mpeg', 'video/mp4'];
                let valid = true;

                this.$refs.checkinFiles[0].dropzone.files.forEach((file) => {
                    if (!validFileTypes.includes(file['type'])) {
                        valid = false;
                    }
                });

                if (valid === false) {
                    toastr.error('Please upload only images and MP4 videos');
                    return false;
                }
            }

            return true;
        },


        async submitEvaluation(evaluation, checkin, meeting) {

            if (!checkin.checkin || !checkin.checkin.id) {
                await this.submitCheckin(checkin.id, checkin.week);
                await this.getCheckins();
                checkin = this.checkins.find((c) => { return c.id === checkin.id });

            }



            this.$nextTick(() => {

                if ((evaluation.participation === 'bad' || evaluation.participation === 'meh') && !evaluation.sessionComments) {
                    let status = evaluation.participation;
                    if (status === 'meh') status = 'not great';
                    toastr.error('Please explain why the session was '+status+' this week');
                    return false;
                }

                if ((evaluation.progress === 'bad' || evaluation.progress === 'meh') && !evaluation.comments) {
                    let status = evaluation.progress;
                    if (status === 'meh') status = 'not great';
                    toastr.error('Please explain why progress was '+status+' this week');
                    return false;
                }

                if (!meeting || (meeting.location && meeting.location !== 'remote')) {
                    if (this.campusMentorAttended === 'yes') {
                        if (!evaluation.comments || !evaluation.participation || !evaluation.progress) {
                            toastr.error('Please complete the evaluation 1');
                            return false;
                        }
                    } else {
                        if (!evaluation.reasonMissed || !evaluation.comments || !evaluation.progress) {
                            toastr.error('Please complete the evaluation 2');
                            return false;
                        }
                    }
                } else {
                    
                    if (this.attended(checkin, evaluation)) { 
                                                                                  
                        if (!evaluation.comments || !evaluation.participation || !evaluation.progress) {
                            toastr.error('Please complete the evaluation 3 ');
                            return false;
                        }
                    } else {

                        if ((!evaluation.reasonMissed || !evaluation.comments || !evaluation.progress)  && localStorage.user_id != '1076') {
                            // Temporary exemption for Fenner Rockclife,
                            // who somehow scheduled online meetings as a campus mentor
                            toastr.error('Please complete the evaluation 4');
                            return false;
                        }
                    }
                }

                evaluation.checkinId = checkin.checkin.id;
                evaluation.week = checkin.checkin.week;

                if (evaluation.important === true) {
                    let mentee = this.mentees.find((m) => { return m.id === evaluation.studentId });
                    evaluation.studentName = mentee.firstName + ' ' + mentee.lastName;
                }


                checkins.submitEvaluation(evaluation).then(async (response) => {
                    response.success === true ? toastr.success('Evaluation submitted') : toastr.error('Error submitting evaluation');
                    await this.getCheckins();
                    this.openCheckin = checkin.id;
                    this.$bus.$emit('reloadCheckins')
                });
            });
        },
        async submitCheckin(id, week) {
            
            if (this.isSubmitting === true) {
                return;
            }
            
            this.isSubmitting = true;

            this.newCheckin.alertId = id;
            this.newCheckin.week = week;

            const valid = this.validateCheckin();

            if (valid === false) {
                this.isSubmitting = false;
                return;
            }


            if (localStorage.roles.includes('Student') || localStorage.roles.includes('CampusStudent')) {
                this.newCheckin.files = [];
                const bucket = 'tto-mentor-checkins';

                for (let file of this.$refs.checkinFiles[0].dropzone.files) {                    
                    let fragments = file.name.replace(/&|\$|@|=|;|:|\%|\+|,|\?/g, '').split('.');
                    fragments[0] = fragments[0] + '_' + Math.floor(Math.random() * (999 - 100 + 1) + 100);
                    let filename = fragments.join('.');
                    const signature = await aws.signature(file, filename, bucket);
                    const presigned = await aws.getPresignedUrl(self, bucket, filename, 'putObject');
                    const upload = await aws.upload(file, filename, signature, bucket, presigned.data);
                    this.newCheckin.files.push(upload.url);
                }

            }


            if (localStorage.roles.includes('Mentor')) {
                this.newCheckin.students = this.newCheckin.students.map((s) => { s.week = week; return s; });
            }

            this.$store.dispatch('toggle', { type: 'loading', boolean: true });


            return new Promise((resolve, reject) => {
                checkins.create(this.newCheckin).then(async (response) => {

                    this.$store.dispatch('toggle', { type: 'loading', boolean: false });

                    if (response.success === true) {
                        
                        this.isSubmitting = false;

                        toastr.success('Check-in submitted');
                        await this.getCheckins();

                        this.newCheckin = {
                            overallStatus: null,
                            overallStatusDetails: null,
                            mentorshipStatus: null,
                            mentorshipStatusDetails: null,
                            machineStatus: null,
                            workstationUsage: null,
                            important: null,
                            reasonMissed: null
                        }


                        this.$bus.$emit('checkin', id);

                        if (localStorage.roles.includes('Mentor')) {
                            this.getGroup();

                        } else {
                            this.openCheckin = null;
                        }

                        resolve();

                    } else {
                        toastr.error('Error submitting check-in');
                        this.isSubmitting = false;
                        reject();
                    }
                }).catch((e) => {
                    console.log(e);
                    this.isSubmitting = false;
                    toastr.error('Error submitting check-in');
                });
            });
        },
        areCampusStudents(students) {
            let campus = false;
            for (let student of students) {
                if (student.roles.includes('CampusStudent') || student.transitioned === true) {
                    campus = true;
                }
            }

            return campus;
        },

        formatShortDate(date) {
            return moment.tz(date, 'America/Vancouver').format('MMM D');
        },

        formatFullDate(date) {
            return moment.tz(date, 'America/Vancouver').format('MMM D, YYYY [at] h:mma');
        },

        selectCheckin(checkinId) {
            if (this.openCheckin === checkinId) {
                this.openCheckin = null;
            } else {
                this.openCheckin = checkinId;
                this.$nextTick(() => {
                    this.scrollToCheckin(checkinId);
                });
            }
        },

        scrollToCheckin(checkinId) {
            document.getElementById(`checkin_${checkinId}`).scrollIntoView({
                behavior: 'smooth',
            });
        },
        attended(checkin, evaluation) {
            if (evaluation) {
                const start = moment(checkin.startDate).startOf('week').add(1,'day').toDate()
                const end = moment(checkin.startDate).endOf('week').add(1,'day').toDate()
                const mentee = this.mentees.find(m => m.id === evaluation.studentId);
                const weeksMeetings = mentee.meetings.filter((m) => { return new Date(m.startTime) > start && new Date(m.startTime) < end });
                const meeting = weeksMeetings.find(m => m.attendees.includes(localStorage.user_id));
                if (meeting) {
                    return true;
                } 
                return false;                
            } else {
                if (checkin.meeting && checkin.meeting.location && checkin.meeting.location !== 'remote') return true;
                return checkin.meeting && checkin.meeting.attendees.map(a => a.toString()).includes(localStorage.user_id);
            }
        },
    },

    watch: {
        '$route': function(route) {
            this.openCheckin = route.query.id;
            VueScrollTo.scrollTo('#checkin_' + this.openCheckin, 0);
        }
    },
    computed: {

        isOnlineStudent() {
            if (localStorage.transitioned === 'true' || localStorage.roles.includes('CampusStudent')) {
                return false;
            }
            return true;
        },
        isAlumni() {
            return localStorage.group.split(',').includes('22');
        },

        currentWeek() {
            if (this.$store.getters.currentWeek) {
                const currentWeek = this.$store.getters.currentWeek + 1;
                return currentWeek;
            }
        }
    }
}

</script>
<style lang="scss">
.dropzone-wrapper {
    width: 100%;
    margin: 10px 0 25px;
    padding: 0 0 0 20px;
    max-width: 600px;

    .dropzone {
        border: none;
        background: #222 !important;
        //max-width: 400px
    }
}

</style>
<style lang="scss" scoped>
.checkbox-wrapper {
    cursor: pointer;
}

.mentor-files {
    li {
        padding: 1rem;
    }
}

.status {
    position: absolute;
    height: 100%;

    bottom: 0;
    right: 0;

    span {
        position: absolute;
        bottom: 10px;
        right: 20px;
    }
}

.mentees {
    background: #2C2C2C;

    margin-top: 20px;
    padding: 0 40px 25px;

    >h4:first-of-type {
        margin-top: 40px;
        border-bottom: none;
        padding-bottom: 0;
    }

    .submit-evaluation {
        margin: 10px 0 0;
    }
}

.student-checkin {

    .row {
        margin-bottom: 10px;
    }

    .col-xs-3 {
        background: #363636;
        font-weight: bold;
        padding: 5px 15px;
    }

    .col-xs-9 {
        padding-right: 0;
    }

    .padded {
        padding-top: 5px;
        padding-bottom: 5px;
    }

    .overall-status {
        text-transform: capitalize;
    }

    .files {
        padding: 0;
        margin-right: -10px;

        li {
            padding: 0 10px 10px 0;
        }
    }

    .submission-date {
        margin-top: 20px;
    }
}

.pagination {
    display: flex;
    align-items: center;
    justify-content: flex-end;

    ul {
        margin-left: 1rem;
        display: flex;
    }

    li {
        padding: 0;
        border: none;
    }
}

.tabs {
    font-style: normal;
    border-bottom: none;

    &>ul {
        border-bottom: 2px solid #999;
        margin-bottom: 1rem;

        &>li {
            font-style: normal;
            font-size: 1.8rem;
            padding-top: 0;
            padding-bottom: 0;
            background: #222;
            border: none;
            margin-right: .5rem;
        }

        li.active {
            background: #999;
            color: #222;
        }
    }

    .files {
        display: flex;

        li {
            border: none;
        }
    }

    .student {
        border: 1px solid #b0b0b0;
        padding: 1rem;
        border-radius: 3px;

        .col-xs-6 {
            padding: 0;
        }
    }
}

.thumbnail-image {
    padding: 0;

    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        padding: 0;
        margin: 0;
        border-right: 4px solid #161616;
    }
}

.panel-body {
    background: #222 !important;
}

.status-line {
    display: flex;

    .status-icon {
        font-size: 20px;

        &.fa-check {
            color: rgb(63, 235, 155);
        }

        &.fa-times {
            color: red;
        }

        &.animated {
            animation-name: pulse;
            animation-duration: 1.2s;
            animation-fill-mode: both;
            animation-iteration-count: infinite;
        }
    }

    .status-date {
        margin-left: 8px;
    }

    .status-extra {
        margin-left: 12px;
        padding: 0 8px;
        background-color: #999;
        color: #222;

        &.status-extra-bad {
            background-color: red;
            font-weight: bold;
        }
    }
}

ul.checkins {
    padding: 0 2rem;

    &>li {
        margin: 3rem auto;

        &.disabled {
            opacity: .5;
            pointer-events: none;
        }

        h3 {
            color: #3cf;
            font-weight: 100;
            padding: 1rem;
            margin: 0 0 15px;
            padding: 0;
        }
    }

    .main {
        background: #363636;
        margin: 0;
        padding: 15px 20px 10px;
        border-bottom: 4px solid #444;

        .col-xs-6 {
            padding: 0;
        }
    }

    .icon {
        background: #161616;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 10px;

        i {
            font-size: 64px;
            color: #666;
        }

        img {
            width: 100%;
        }
    }

    .submitted {
        color: green;
    }

    .overdue {
        color: red;
    }

    .blue-stripe {
        visibility: hidden;

        &::before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            width: 3px;
            height: 91px;
            background-color: #33ccff;
        }
    }
}

ul.files {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    padding: 1rem;

    li {
        width: 25%;
        padding: 1rem;
    }

    a {
        display: inline-block;
        width: 100%;
        border: 2px solid #444;

        &:hover {
            border-color: #33ccff;
        }
    }

    img {
        width: 100%;
    }
}

.checkin.row {
    cursor: pointer;
    display: flex; // to make items stretch vertically and match heights
    height: 91px;

    &:hover {
        .blue-stripe {
            visibility: visible;
        }
    }
}

.scroll-wrapper {
    padding: 0;
    background: #2C2C2C;
}

.dot {
    width: 14px;
    height: 14px;
    border: 1px solid #b0b0b0;
    border-radius: 50%;
    display: inline-block;
    cursor: pointer;
    position: relative;
    top: 2px;
    margin-right: .5rem;

    &.selected {
        background: #33ccff;
        border-color: #33ccff;
    }
}

.radio-wrapper {
    margin: 6px 0 20px 20px;

    input {
        display: none;
    }

    input:checked+.dot {
        background: #33ccff;
        border-color: #33ccff;
    }
}

form.checkin,
.completed-checkin {
    //max-height: 650px; // With this enabled, you'll get scrollbars
    padding: 0 40px 25px;
    margin-top: -25px;

    button {
        margin: 10px 0;
    }

    .submission-date {
        margin-top: 40px;
    }
}

h4 {
    color: #b0b0b0;
    font-weight: 100;
    font-size: 28px;
    margin: 60px 0 20px;
    border-bottom: 2px solid #444;
    padding-bottom: 15px;
    max-width: 600px;
}

h5 {
    color: #b0b0b0;
    font-weight: 100;
    font-size: 24px !important;
    margin: 50px 0 20px;
    border-bottom: 2px solid #444;
    padding-bottom: 15px;
    max-width: 600px;
}

.textarea-wrapper {
    width: 100%;
    max-width: 600px;
    margin: 10px 0 25px;
    padding: 0 0 0 20px;
}

textarea.form-control {
    background: #222 !important;
    height: 8rem;
    border: none !important;
    padding: 1rem !important;

    &::-webkit-scrollbar {
        width: 10px;
    }

    &::scrollbar {
        width: 10px;
    }
}

@keyframes pulse {
    from {
        transform: scale3d(1, 1, 1);
    }

    50% {
        transform: scale3d(1.2, 1.2, 1.2);
    }

    to {
        transform: scale3d(1, 1, 1);
    }
}

.submission-date {
    font-style: italic;
    color: #777;
}

.completed-demo-reel {
    .submission-date {
        margin-top: 20px;
    }
}

.mentor-feedback,
.completed-demo-reel-feedback {
    .col-xs-6 {
        &:first-of-type {
            padding-left: 0;
        }

        &:last-of-type {
            padding-right: 0;
        }
    }

    .files {
        padding: 0;
        margin-right: -10px;

        li {
            padding: 0 10px 10px 0;
        }
    }

    .submission-date {
        margin-top: 40px;
    }
}

.no-checkins {
    text-align: center;
    padding: 2rem 1rem;
    font-size: 1.8rem;
}

</style>



// WEBPACK FOOTER //
// MentorCheckins.vue?391fde32